<template>
	<div class="mm-page-main" v-loading="loading">
		<div class="page-header">
			<div class="page-title">修改現金賬戶</div>
			<div @click="pageback" class="page-back">
				<svg class="icon svg-icon" aria-hidden="true">
					<use xlink:href="#icon-back"></use>
				</svg>
			</div>
		</div>
		<div class="pagemain">
			<el-form ref="form" :model="form"  label-width="150px" label-position="left">
				<div class="form-group">
					<div class="form-group-content">
						<div class="mm-row-block">
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="門店" >
										<div>{{row.storename}}</div>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="類型" >
										<div style="display: flex; align-items: center;">
											<div v-if="row.type0 == 0 ">現金</div>
											<div v-if="row.type0 == 1 ">電匯</div>
										</div>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="幣種" >
										<div style="display: flex; align-items: center;">
											<div><img style="width: 30px; height: 30px; display: block;" :src="apiurl+row.thumb"></div>
											<div style="margin-left: 10px;">{{row.name}}</div>
										</div>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="現金金額" >
										<el-input v-model="form.money"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="成本價" >
										<el-input v-model="form.cost"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="港幣現金金額" >
										<el-input v-model="form.hkd"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="應收賬款" >
										<el-input v-model="form.income_money"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="應付賬款" >
										<el-input v-model="form.pay_money"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="結餘" >
										<el-input v-model="form.surplus_money"></el-input>
									</el-form-item>
								</div>
							</div>
							<div class="mm-row">
								<div class="mm-col">
									<el-form-item label="港幣結餘" >
										<el-input v-model="form.surplus_hkd"></el-input>
									</el-form-item>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div class="form-submit">
					<el-button @click="formsubmit('form')" type="primary">提交</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				loading: false,
				row: {},
				form: {},
				
			};
		},
		methods: {
			pageback() {
				this.$router.go(-1);
			},
			formsubmit(form) {
				this.loading = true;
				let data = this.form;
				this.post('/api/funds/edit_cash_account_save', {
					data: data
				}).then((res) => {
					this.loading = false;
					
					if (res == 'success') {
						this.$message({
							showClose: true,
							message: '修改現金賬戶成功！',
							type: 'success',
							onClose: (() => {
								this.pageback();
							})
						});
					} else {
						this.$message({
							showClose: true,
							message: '修改現金賬戶失敗，請重試！',
							type: 'error',
						});
					}
				
					
				}).catch((err) => {
					this.loading = false;
					console.log(err)
				});
			},
			geteditdata() {
				let form = {};
				let row = this.$route.params.row;
				form.type = 0;
				form.store_id = row.store_id;
				form.currency_id = row.currency_id;
				form.type0 = row.type0;
				form.money = row.money;
				form.cost = row.cost;
				form.hkd = row.hkd;
				form.income_money = row.income_money;
				form.pay_money = row.pay_money;
				form.surplus_money = row.surplus_money;
				form.surplus_hkd = row.surplus_hkd;
				this.row = row;
				this.form = form;

			},
		},
		created() {

			this.geteditdata();
		}

	};
</script>
<style scoped>
	.mm-row {
		width: 50%;

	}
</style>
